<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/shoukuan.png" class="jxyd-imgicon" />
				操作收款单
			</div>
			<button class="jxyd-button jxyd-primary" title="过账" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				过账
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-sync" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>

					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							付款人
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.payer" filterable clearable
								@on-change="payerSelectChange">
								<Option v-for="item in payerList" placeholder="请选择付款人" :value="item.name"
									:key="item.id+item.name">
									{{item.name}}
								</Option>
							</Select>
						</td>
					</tr>
					<tr>
						<!-- <td class="key">
			                折扣(%)
			                <font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*</font>
			            </td>
			            <td style="text-align: left;">
			                <input type="number" v-model="documentItem.discount" placeholder="请输入折扣" class="baseinfo-input"
			                       @blur="discountBlur" />
			            </td> -->
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/feiyong.png" class="jxyd-imgicon" />
						费用信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<Table stripe :columns="receiptDetailColumn" :data="salesListData"
					@on-selection-change="salesListSeleChange"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div id="voucher-bottomBar">
				<table style="float: left;">
					<tr>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">合计：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.amount}}</span>
						</td>
						<td style="font-size: 16px;font-weight: bold;color: var(--font1Color);padding-left:15px;">支付方式：
						</td>
						<td>
							<SelectTradeMethod :value.sync='documentItem.payWay' :accountPid='accountPid'>
							</SelectTradeMethod>
						</td>
					</tr>
				</table>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已过账</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
			<div id="hiprint-printTemplate" class="designer-canvas"></div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import SelectTradeMethod from '@/components/SelectTradeMethod'
	import DocumentFile from '@/components/DocumentFile'
	import printMixin from '@/mixins/printMixin' // 引入打印 mixin
	export default {
		name: 'receiptlistfunc',
		mixins: [printMixin],
		components: {
			SelectTradeMethod,
			DocumentFile
		},
		data() {
			return {
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					amount: 0,
					discount: 100,
					receiptDetailLists: [],
					payer: '',
					userId: '',
					userName: '',
					creator: parseInt(localStorage.getItem("userId")),
					note: '',
					payWay: '',
					checkState: 1, //未过账
					fileList: []
				},
				receiptDetailColumn: [{
						type: 'selection',
						width: 60,
						align: 'center',
						fixed: 'left'
					},
					{
						title: '单据类型',
						key: 'type',
						width: 150
					},
					{
						title: '单据编号',
						key: 'listCode',
						render: (h, params) => {
							return [h('a', {
								class: 'jxyd-a',
								on: {
									click: (val) => {
										if (params.row.type == '销售单') {
											this.$router.push({
												path: 'saleslistdetail',
												query: {
													salesListCode: params.row.listCode
												}
											});
										} else if (params.row.type == '采购退货单') {
											this.$router.push({
												path: 'returnlistdetail',
												query: {
													returnListCode: params.row.listCode
												}
											});
										} else if (params.row.type == '其它收款单') {
											this.$router.push({
												path: 'otherreceiptlistdetail',
												query: {
													otherCostListCode: params.row.listCode
												}
											});
										}
									}
								}
							}, params.row.listCode)];
						}
					},
					{
						title: '单据日期',
						key: 'businessDate',
					},
					{
						title: '单据金额',
						key: 'listAmount',
					},
					{
						title: '已核销金额',
						key: 'amountPaid',
					},
					{
						title: '未核销金额',
						key: 'amountUnpaid',
					}
				],
				userList: [],
				payerList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				salesListData: [],
				accountPid: 'sfkzh'
			}
		},

		methods: {
			emptyForm() {
				this.documentItem.id = 0;
				//this.documentItem.code = '';
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
				this.documentItem.amount = 0;
				this.documentItem.receiptDetailLists = [];
				this.documentItem.payer = '';
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.userName = '';
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = '';
				this.documentItem.payWay = '';
				this.documentItem.checkState = 1;
				this.salesListIds = [];
				this.documentItem.discount = 100;
				this.documentItem.fileList = [];
				this.getNextCode();
			},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}

				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {}

				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}

				if (this.documentItem.payer == '') {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择付款人"
					});
					return false;
				}
				// if (!this.documentItem.discount) {
				//     this.$Notice.error({
				//         title: '错误提示',
				//         duration: 3,
				//         desc: "请输入折扣"
				//     });
				//     return false;
				// } else if (isNaN(this.documentItem.discount)) {
				//     this.$Notice.error({
				//         title: '错误提示',
				//         duration: 3,
				//         desc: "折扣格式有误"
				//     });
				//     return false;
				// } else if (parseInt(this.documentItem.discount) < 1 || parseInt(this.documentItem.discount) > 100) {
				//     this.$Notice.error({
				//         title: '错误提示',
				//         duration: 3,
				//         desc: "折扣不得小于1，大于100"
				//     });
				//     return false;
				// }

				if (this.documentItem.amount <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择单据"
					});
					return false;
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/ReceiptList/EditReceiptList', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录收款单操作
					var log = {
						FlowId: response.data,
						Title: '收款单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此收款单' : '创建了此收款单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}

					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});


				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				let path = '';
				if (self.documentItem.id) {
					path = '/api/ReceiptList/EditReceiptList';
				} else {
					path = '/api/ReceiptList/AddReceiptList';
				}
				request.post(path, self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录收款单操作
					var log = {
						FlowId: self.documentItem.id ? response.data : response.data.id,
						Title: '收款单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此收款单' : '创建了此收款单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					if (!self.documentItem.id) {
						self.documentItem = response.data;
					} else {
						self.documentItem.id = response.data;
					}
					self.checkReceiptList([self.documentItem], '收款单过账后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/ReceiptList/GetNextCode', {
					params: {
						prefix: 'SKD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到过账流程？',
					onOk() {
						request.post('/api/ReceiptList/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "收款单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '收款单日志',
									OperationContent: '回滚了此收款单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getReceiptList(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkReceiptList(objs, func) {
				var self = this;
				if (objs.length <= 0) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}

				let stateObj = [];
				let receiptIds = [];
				for (var i = 0; i < objs.length; i++) {
					if (objs[i].checkState != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "选中记录中包含不可过账的数据！"
						});
						return;
					}
					stateObj.push({
						id: objs[i].id,
						state: 3
					});
					receiptIds.push(objs[i].id);
				}
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/ReceiptList/CheckReceiptList', stateObj).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							let tag = '';
							tag = '过账';
							request.post('/api/ReceiptList/UpdatePaymentState', receiptIds).then(function(
								response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '更新单据状态失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							var log = [];
							for (var i = 0; i < receiptIds.length; i++) {
								//记录收款单操作
								log.push({
									FlowId: receiptIds[i],
									Title: '收款单日志',
									OperationContent: tag + '了此收款单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: tag + '成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['ReceiptList.Add', 'ReceiptList.Edit', 'ReceiptList.Delete',
						'ReceiptList.Audit', 'ReceiptList.BatchAudit', 'ReceiptList.Print',
						'ReceiptList.Rollback', 'ReceiptList.Export', 'ReceiptList.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'ReceiptList.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'ReceiptList.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'ReceiptList.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'ReceiptList.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'ReceiptList.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'ReceiptList.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'ReceiptList.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'ReceiptList.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'ReceiptList.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			printList() {
				const printData = this.formatPrintData([this.documentItem])
				// 使用 mixin 提供的打印方法
				this.printWithTemplate(printData, 'receiptList')
			},
			formatPrintData(rawData) {
				// rawData 已经是数组
				if (!Array.isArray(rawData)) {
					console.error('formatPrintData: rawData 不是数组', rawData);
					return [];
				}
			
				// 辅助函数：添加序号
				const addSerialNo = (arr) => arr.map((item, idx) => ({
					...item,
					serialNo: idx + 1
				}));
			
				// 辅助函数：安全获取数值
				const safeNumber = (value) => {
					const num = Number(value);
					return isNaN(num) ? 0 : num;
				};
			
				// 辅助函数：计算合计
				const calcTotals = (arr, fields) => {
					if (!Array.isArray(arr) || arr.length === 0) {
						const emptyTotals = {};
						fields.forEach(f => {
							emptyTotals[f] = 0;
						});
						return emptyTotals;
					}
			
					const totals = {};
					fields.forEach(f => {
						totals[f] = 0;
					});
			
					arr.forEach(item => {
						fields.forEach(f => {
							totals[f] += safeNumber(item[f]);
						});
					});
			
					return totals;
				};
			
				// 格式化日期
				const formatDate = (dateStr) => {
					if (!dateStr) return '';
					if (dateStr instanceof Date) {
						const year = dateStr.getFullYear();
						const month = String(dateStr.getMonth() + 1).padStart(2, '0');
						const day = String(dateStr.getDate()).padStart(2, '0');
						return `${year}-${month}-${day}`;
					}
					if (typeof dateStr === 'string') {
						// 处理 "2026-03-19 00:00:00" 或 "2026-03-19" 格式
						return dateStr.split(' ')[0];
					}
					return '';
				};
			
				// 格式化单条收款单记录
				const formatSingle = (record) => {
					if (!record) return {};
			
					// 格式化费用信息（收款明细列表 - 关联的销售单等）
					const receiptDetails = record.receiptDetailLists || [];
					let logisticsInfosRaw = receiptDetails.map(item => ({
						type: item.type || '',
						listCode: item.listCode || '',
						businessDate: formatDate(item.businessDate),
						listAmount: safeNumber(item.listAmount),
						amountPaid: safeNumber(item.amountPaid),
						amountUnpaid: safeNumber(item.amountUnpaid),
						note: item.note || ''
					}));
			
					// 添加序号
					let logisticsInfos = addSerialNo(logisticsInfosRaw);
			
					// 添加合计行
					if (logisticsInfosRaw.length > 0) {
						const totals = calcTotals(logisticsInfosRaw, ['listAmount', 'amountPaid', 'amountUnpaid']);
						logisticsInfos.push({
							serialNo: '',
							type: '',
							listCode: '',
							businessDate: '',
							listAmount: totals.listAmount,
							amountPaid: totals.amountPaid,
							amountUnpaid: totals.amountUnpaid,
							note: '合计',
							__style__: {
								fontWeight: 'bold',
								backgroundColor: '#f9f9f9'
							}
						});
					}
			
					// 返回格式化后的数据
					return {
						code: record.code || '',
						userName: record.userName || '',
						businessDate: formatDate(record.businessDate),
						discount: safeNumber(record.discount),
						amount: safeNumber(record.amount),
						payWay: record.payWay || '',
						payer: record.payer || '', // 付款人（收款单中是付款人）
						note: record.note || '',
						originalPrice: safeNumber(record.originalPrice),
						logisticsInfos: logisticsInfos
					};
				};
			
				// 直接返回格式化后的数组
				return rawData.map(record => formatSingle(record));
			},
			getReceiptList(listId) {
				let self = this;
				request.get('/api/ReceiptList/GetReceiptList', {
					params: {
						id: listId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.documentItem = response.data;
					self.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd');
					self.salesListData = self.documentItem.receiptDetailLists;
				}).catch(function(error) {})
			},
			initPayeeSelect() {
				let self = this;
				request.get('/api/Util/GetSupplierAndCustomer').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取付款人数据失败：" + response.errorMsg
						});
						return;
					}
					self.payerList = response.data;
				}).catch(function(error) {})
			},
			payerSelectChange(val) {
				this.initSalesList(val);
			},
			initSalesList(val) {
				let self = this;
				request.get('/api/ReceiptList/GetSalesList', {
					params: {
						payer: val
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取单据数据失败：" + response.errorMsg
						});
						return;
					}
					self.salesListData = response.data;
				}).catch(function(error) {})
			},
			salesListSeleChange(items) {
				// if (!this.documentItem.discount || this.documentItem.discount < 1 || this.documentItem.discount > 100) {
				//     this.documentItem.discount = 100;
				// }
				this.documentItem.amount = 0;
				this.documentItem.receiptDetailLists = [];
				for (var i = 0; i < items.length; i++) {
					this.documentItem.receiptDetailLists.push({
						listCode: items[i].listCode,
						type: items[i].type,
						businessDate: items[i].businessDate,
						listAmount: items[i].listAmount,
						amountPaid: items[i].amountPaid,
						amountUnpaid: items[i].amountUnpaid
					});
					this.documentItem.amount += items[i].amountUnpaid;
				}
				this.documentItem.amount = formatNum(this.documentItem.amount);
			},
			discountBlur() {
				if (!this.documentItem.discount || this.documentItem.discount < 1 || this.documentItem.discount > 100) {
					this.documentItem.discount = 100;
				}
				this.documentItem.amount = 0;
				this.documentItem.discount = parseInt(this.documentItem.discount);

				for (var i = 0; i < this.documentItem.receiptDetailLists.length; i++) {
					this.documentItem.amount += this.documentItem.receiptDetailLists[i].amountUnpaid;
				}
				this.documentItem.amount = formatNum(this.documentItem.amount * (this.documentItem.discount / 100));
			}
		},
		watch: {
			'$route.query.receiptListId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getReceiptList(param);
					} else {
						this.emptyForm();
					}
				}
			},
			'$route.query.list': {
				immediate: true,
				handler(param) {
					if (param) {
						let self = this;
						setTimeout(function() {
							self.documentItem.payer = param.businessPeopleName;
							self.initSalesList(self.documentItem.payer);
						}, 300)
					}
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initPayeeSelect();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
</style>